import { GatewayLocationModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/locations/models/outputs/gateway-location.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { LocationListAddressCell } from './location-list-address.cell';
import { LocationListAddressHeader } from './location-list-address.header';

export const LocationListAddressColumn: IdentifiedColumnDef<
  GatewayLocationModel,
  GatewayLocationModel['address']
> = {
  enableSorting: false,
  header: LocationListAddressHeader,
  cell: LocationListAddressCell,
};
